module.exports = __webpack_public_path__ + "img/IMG_1443_edited.325383d2.jpg";